import { Routes, Route, Navigate } from "react-router-dom";

import DashboardLayout from "./components/DashboardLayout";
import Dashboard from "./components/Admin/Dashboard";  
import ManageProfile from "./components/ManageProfile";
import Home1 from "./components/Home1";
import About from "./components/About";
import Product from "./components/Product";
import Cont from "./components/Cont";
import Login from "./components/Login";
import ManageUser from "./components/Admin/ManageUser"

import Inventory from "./components/Admin/Inventory";
import Orderhistory from "./components/Admin/Orderhistory";

import Reward from "./components/Admin/Reward";
import Team from "./components/Admin/Team";


import Earningplan from "./components/Admin/Earningplan";
import Withdrawal from "./components/Admin/Withdrawal";
import Setting from "./components/Admin/Setting";
import Enquiry from "./components/Admin/Enquiry";

import Transactionhistory from "./components/Admin/Transactionhistory";
import EditProduct from "./components/Admin/Editproduct";
import Register from "./components/Signup/Register"
import Download from "./components/Download"
import AddTermCondition from "./components/Admin/AddTermCondition";


function App() {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  // const userData = JSON.parse(localStorage.getItem("userData"));

  // console.log(userData,'user data');
const storedUserData = localStorage.getItem("userData");
const userData = storedUserData ? JSON.parse(storedUserData) : null;

console.log(userData);


  return (
    <Routes>
      {!isLoggedIn && (
        <>
          {/* <Route path="/" element={<Home />} /> */}
           <Route path="/" element={<Home1/>} />
          <Route path="/login" element={<Login />} />
          <Route path="/about" element={<About />} />
          {/* <Route path="/product" element={<Product />} /> */}
               <Route path="/download" element={<Download />} />
          <Route path="/contact" element={<Cont />} />
          <Route path="/register" element={<Register/>}/>
          <Route path="*" element={<Navigate to="/login" />} />
        </>
      )}

      {isLoggedIn && (
        <>
      

          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />
          </Route>

          <Route path="/profile" element={<DashboardLayout />}>
            <Route index element={<ManageProfile />} />
          </Route>
             <Route path= "/inventory" element={<DashboardLayout />}>
            <Route index element={<Inventory />} />
          </Route>

          <Route path="/users" element={<DashboardLayout />}>
            <Route index element={<ManageUser  userData={userData} />} />
          </Route>
          
          <Route path="/withdraw" element={<DashboardLayout />}>
            <Route index element={<Withdrawal/>} />
          </Route>
          
          <Route path="/orders" element={<DashboardLayout />}>
            <Route index element={<Orderhistory userData={userData}/>} />
          </Route>
             <Route path=  "/enquiry" element={<DashboardLayout />}>
            <Route index element={<Enquiry/>} />
          </Route>
            <Route path="/team" element={<DashboardLayout />}>
            <Route index element={<Team/>} />
          </Route>
             <Route path=  "/reward" element={<DashboardLayout />}>
            <Route index element={<Reward />} />
          </Route>
    
    

          
         <Route path="/setting" element={<DashboardLayout />}>
  <Route index element={<Setting/>} />
</Route>
          
<Route path="/edit-product/:id" element={<DashboardLayout />}>
  <Route index element={<EditProduct />} />
</Route>



          

       <Route path="/transaction" element={<DashboardLayout />}>
  <Route index element={<Transactionhistory/>} />
</Route>




      <Route path="/earning" element={<DashboardLayout />}>
  <Route index element={<Earningplan />} />
</Route>

  <Route path="/term-condition" element={<DashboardLayout />}>
  <Route index element={<AddTermCondition    userData={userData}/>} />
</Route>


          <Route path="*" element={<Navigate to="/dashboard" />} />
        </>
      )}
    </Routes>
  );
}

export default App;
